import { IApplicationState, TBoardId } from '../../../../types/types';
import { getBoard } from '../../selectors/getBoardById';
import { META_WARNING_AUTOBCKUPS_FAILED } from '../../../../view/react_components/main/topBar/hocs/TopBarWarningHOC/constants';

export const hasAutoBackupsWarning = (state: IApplicationState, boardId: TBoardId): boolean => {
    const board = getBoard(state, boardId);
    return board.meta && board.meta.warnings && board.meta.warnings.includes(META_WARNING_AUTOBCKUPS_FAILED);
}
